var OCS = OCS || {};

OCS.Constants = OCS.Constants || {};
OCS.Constants.DEBUG = true;
OCS.Constants.ENVIRONMENT = "PRODUCTION";

OCS.is_on_dev_server = function () {
    return (OCS.Constants.ENVIRONMENT == "DEVELOPMENT");
};

OCS.is_on_test_server = function () {
    return (OCS.Constants.ENVIRONMENT == "STAGING");
};

OCS.is_on_production_server = function () {
    return (OCS.Constants.ENVIRONMENT != "DEVELOPMENT" && OCS.Constants.ENVIRONMENT != "STAGING");
}

OCS.set_server_environment = function () {
    var parser = document.createElement('a');
    parser.href = document.URL;
    if (parser.hostname.match(/\.dev\.mesonet\.org$/) ||
            parser.hostname == "localhost" || // local testing
            parser.hostname == "127.0.0.1" || // local testing
            parser.hostname.substr(parser.hostname.length - 6, 6) == '.local' // local testing
            ) {
        OCS.Constants.ENVIRONMENT = "DEVELOPMENT";
    } else if (parser.hostname.match(/\.test\.mesonet\.org$/)) {
        OCS.Constants.ENVIRONMENT = "STAGING";
    }
};

OCS.set_server_environment();

OCS.Constants.msgs = {
    xmpp_device_kicked_off: "This device has been disconnected due to a new desktop connection detected. Please keep in mind that only 1 browser is allowed to connect per computer.",
    xmpp_device_failed_to_connect: "This device has failed to connect to the xmpp server. Live updates not available. Try reloading the page or contacting the mesonet."
}
OCS.Constants.CONTENT_URL = (OCS.is_on_production_server()) ? "//content.mesonet.org" : "//xcontent.mesonet.org";

OCS.Constants.EMBEDDABLE_URL = 'Embeddable URL (Usually Special Products)';
OCS.Constants.EMBEDDABLE_STATIC_URL = 'Embeddable Static URL (Usually Special Products - Does Not Update)';
OCS.Constants.EMBEDDABLE_IMAGE = 'Embeddable Image (Either Output Directly or From a Script)';
OCS.Constants.EMBEDDABLE_TEXT = 'Embeddable Text (Either .txt File or Output From a Script)';
OCS.Constants.DYNAMIC_MAP = 'Dynamic Map (Interactive JavaScript Based Map)';
OCS.Constants.EXTERNAL_URL = 'External URL (Links Opened in a New Browser Tab)';
OCS.Constants.EMBEDDABLE_PRODUCT = 'Embeddable Product (SVG or partial HTML - body contents only)';
OCS.Constants.NWS_STATIONS = {};
OCS.Constants.NWS_STATIONS.stations = {'KTSA': {'name': 'Tulsa'}, 'KOUN': {'name': 'Norman'}, 'KAMA': {'name': 'Amarillo'}, 'KSHV': {'name': 'Shreveport'}, 'KFWD': {'name': 'Fort Worth'}, 'KICT': {'name': 'Witchita'}, 'KSGF': {'name': 'Springfield'}, 'KPUB': {'name': 'Pueblo'}, 'KDDC': {'name': 'Dodge City'}, 'KABQ': {'name': 'Albuquerque'}, 'KLZK': {'name': 'Little Rock'}, 'KLUB': {'name': 'Lubbock'}, 'KSJT': {'name': 'San Angelo'}};
OCS.Constants.WATCHED_COUNTIES_OBJS = {
    "ARC007": {
        "ID": "ARZ001",
        "CID": "ARC007",
        "NAME": "Benton"
    },
    "ARC015": {
        "ID": "ARZ002",
        "CID": "ARC015",
        "NAME": "Carroll"
    },
    "ARC033": {
        "ID": "ARZ019",
        "CID": "ARC033",
        "NAME": "Crawford"
    },
    "ARC047": {
        "ID": "ARZ020",
        "CID": "ARC047",
        "NAME": "Franklin"
    },
    "ARC057": {
        "ID": "ARZ060",
        "CID": "ARC057",
        "NAME": "Hempstead"
    },
    "ARC061": {
        "ID": "ARZ051",
        "CID": "ARC061",
        "NAME": "Howard"
    },
    "ARC071": {
        "ID": "ARZ021",
        "CID": "ARC071",
        "NAME": "Johnson"
    },
    "ARC073": {
        "ID": "ARZ071",
        "CID": "ARC073",
        "NAME": "Lafayette"
    },
    "ARC081": {
        "ID": "ARZ059",
        "CID": "ARC081",
        "NAME": "Little River"
    },
    "ARC083": {
        "ID": "ARZ030",
        "CID": "ARC083",
        "NAME": "Logan"
    },
    "ARC091": {
        "ID": "ARZ070",
        "CID": "ARC091",
        "NAME": "Miller"
    },
    "ARC097": {
        "ID": "ARZ041",
        "CID": "ARC097",
        "NAME": "Montgomery"
    },
    "ARC087": {
        "ID": "ARZ011",
        "CID": "ARC087",
        "NAME": "Madison"
    },
    "ARC109": {
        "ID": "ARZ052",
        "CID": "ARC109",
        "NAME": "Pike"
    },
    "ARC113": {
        "ID": "ARZ040",
        "CID": "ARC113",
        "NAME": "Polk"
    },
    "ARC127": {
        "ID": "ARZ037",
        "CID": "ARC127",
        "NAME": "Scott"
    },
    "ARC131": {
        "ID": "ARZ029",
        "CID": "ARC131",
        "NAME": "Sebastian"
    },
    "ARC133": {
        "ID": "ARZ050",
        "CID": "ARC133",
        "NAME": "Sevier"
    },
    "ARC143": {
        "ID": "ARZ010",
        "CID": "ARC143",
        "NAME": "Washington"
    },
    "ARC149": {
        "ID": "ARZ038",
        "CID": "ARC149",
        "NAME": "Yell"
    },
    "COC009": {
        "ID": "COZ099",
        "CID": "COC009",
        "NAME": "Baca"
    },
    "COC071": {
        "ID": "COZ094",
        "CID": "COC071",
        "NAME": "Las Animas"
    },
    "KSC191": {
        "ID": "KSZ092",
        "CID": "KSC191",
        "NAME": "Sumner"
    },
    "KSC189": {
        "ID": "KSZ085",
        "CID": "KSC189",
        "NAME": "Stevens"
    },
    "KSC187": {
        "ID": "KSZ074",
        "CID": "KSC187",
        "NAME": "Stanton"
    },
    "KSC175": {
        "ID": "KSZ086",
        "CID": "KSC175",
        "NAME": "Seward"
    },
    "KSC173": {
        "ID": "KSZ083",
        "CID": "KSC173",
        "NAME": "Sedgwick"
    },
    "KSC151": {
        "ID": "KSZ081",
        "CID": "KSC151",
        "NAME": "Pratt"
    },
    "KSC133": {
        "ID": "KSZ096",
        "CID": "KSC133",
        "NAME": "Neosho"
    },
    "KSC129": {
        "ID": "KSZ084",
        "CID": "KSC129",
        "NAME": "Morton"
    },
    "KSC125": {
        "ID": "KSZ099",
        "CID": "KSC125",
        "NAME": "Montgomery"
    },
    "KSC119": {
        "ID": "KSZ087",
        "CID": "KSC119",
        "NAME": "Meade"
    },
    "KSC099": {
        "ID": "KSZ100",
        "CID": "KSC099",
        "NAME": "Labette"
    },
    "KSC097": {
        "ID": "KSZ080",
        "CID": "KSC097",
        "NAME": "Kiowa"
    },
    "KSC095": {
        "ID": "KSZ082",
        "CID": "KSC095",
        "NAME": "Kingman"
    },
    "KSC081": {
        "ID": "KSZ076",
        "CID": "KSC081",
        "NAME": "Haskell"
    },
    "KSC077": {
        "ID": "KSZ091",
        "CID": "KSC077",
        "NAME": "Harper"
    },
    "KSC069": {
        "ID": "KSZ077",
        "CID": "KSC069",
        "NAME": "Gray"
    },
    "KSC007": {
        "ID": "KSZ090",
        "CID": "KSC007",
        "NAME": "Barber"
    },
    "KSC015": {
        "ID": "KSZ069",
        "CID": "KSC015",
        "NAME": "Butler"
    },
    "KSC019": {
        "ID": "KSZ098",
        "CID": "KSC019",
        "NAME": "Chautauqua"
    },
    "KSC021": {
        "ID": "KSZ101",
        "CID": "KSC021",
        "NAME": "Cherokee"
    },
    "KSC025": {
        "ID": "KSZ088",
        "CID": "KSC025",
        "NAME": "Clark"
    },
    "KSC033": {
        "ID": "KSZ089",
        "CID": "KSC033",
        "NAME": "Comanche"
    },
    "KSC035": {
        "ID": "KSZ093",
        "CID": "KSC035",
        "NAME": "Cowley"
    },
    "KSC037": {
        "ID": "KSZ097",
        "CID": "KSC037",
        "NAME": "Crawford"
    },
    "KSC049": {
        "ID": "KSZ094",
        "CID": "KSC049",
        "NAME": "Elk"
    },
    "KSC057": {
        "ID": "KSZ078",
        "CID": "KSC057",
        "NAME": "Ford"
    },
    "KSC067": {
        "ID": "KSZ075",
        "CID": "KSC067",
        "NAME": "Grant"
    },
    "KSC205": {
        "ID": "KSZ095",
        "CID": "KSC205",
        "NAME": "Wilson"
    },
    "MOC009": {
        "ID": "MOZ102",
        "CID": "MOC009",
        "NAME": "Barry"
    },
    "MOC011": {
        "ID": "MOZ077",
        "CID": "MOC011",
        "NAME": "Barton"
    },
    "MOC097": {
        "ID": "MOZ088",
        "CID": "MOC097",
        "NAME": "Jasper"
    },
    "MOC109": {
        "ID": "MOZ094",
        "CID": "MOC109",
        "NAME": "Lawrence"
    },
    "MOC119": {
        "ID": "MOZ101",
        "CID": "MOC119",
        "NAME": "McDonald"
    },
    "MOC145": {
        "ID": "MOZ093",
        "CID": "MOC145",
        "NAME": "Newton"
    },
    "NMC059": {
        "ID": "NMZ530",
        "CID": "NMC059",
        "NAME": "Union"
    },
    "OKC011": {
        "ID": "OKZ017",
        "CID": "OKC011",
        "NAME": "Blaine"
    },
    "OKC013": {
        "ID": "OKZ052",
        "CID": "OKC013",
        "NAME": "Bryan"
    },
    "OKC015": {
        "ID": "OKZ023",
        "CID": "OKC015",
        "NAME": "Caddo"
    },
    "OKC017": {
        "ID": "OKZ024",
        "CID": "OKC017",
        "NAME": "Canadian"
    },
    "OKC019": {
        "ID": "OKZ046",
        "CID": "OKC019",
        "NAME": "Carter"
    },
    "OKC021": {
        "ID": "OKZ068",
        "CID": "OKC021",
        "NAME": "Cherokee"
    },
    "OKC023": {
        "ID": "OKZ053",
        "CID": "OKC023",
        "NAME": "Choctaw"
    },
    "OKC025": {
        "ID": "OKZ001",
        "CID": "OKC025",
        "NAME": "Cimarron"
    },
    "OKC027": {
        "ID": "OKZ029",
        "CID": "OKC027",
        "NAME": "Cleveland"
    },
    "OKC029": {
        "ID": "OKZ043",
        "CID": "OKC029",
        "NAME": "Coal"
    },
    "OKC031": {
        "ID": "OKZ038",
        "CID": "OKC031",
        "NAME": "Comanche"
    },
    "OKC033": {
        "ID": "OKZ044",
        "CID": "OKC033",
        "NAME": "Cotton"
    },
    "OKC035": {
        "ID": "OKZ057",
        "CID": "OKC035",
        "NAME": "Craig"
    },
    "OKC037": {
        "ID": "OKZ064",
        "CID": "OKC037",
        "NAME": "Creek"
    },
    "OKC039": {
        "ID": "OKZ016",
        "CID": "OKC039",
        "NAME": "Custer"
    },
    "OKC041": {
        "ID": "OKZ063",
        "CID": "OKC041",
        "NAME": "Delaware"
    },
    "OKC043": {
        "ID": "OKZ015",
        "CID": "OKC043",
        "NAME": "Dewey"
    },
    "OKC045": {
        "ID": "OKZ009",
        "CID": "OKC045",
        "NAME": "Ellis"
    },
    "OKC047": {
        "ID": "OKZ012",
        "CID": "OKC047",
        "NAME": "Garfield"
    },
    "OKC049": {
        "ID": "OKZ040",
        "CID": "OKC049",
        "NAME": "Garvin"
    },
    "OKC051": {
        "ID": "OKZ027",
        "CID": "OKC051",
        "NAME": "Grady"
    },
    "OKC053": {
        "ID": "OKZ007",
        "CID": "OKC053",
        "NAME": "Grant"
    },
    "OKC055": {
        "ID": "OKZ034",
        "CID": "OKC055",
        "NAME": "Greer"
    },
    "OKC057": {
        "ID": "OKZ033",
        "CID": "OKC057",
        "NAME": "Harmon"
    },
    "OKC059": {
        "ID": "OKZ004",
        "CID": "OKC059",
        "NAME": "Harper"
    },
    "OKC061": {
        "ID": "OKZ074",
        "CID": "OKC061",
        "NAME": "Haskell"
    },
    "OKC063": {
        "ID": "OKZ032",
        "CID": "OKC063",
        "NAME": "Hughes"
    },
    "OKC065": {
        "ID": "OKZ036",
        "CID": "OKC065",
        "NAME": "Jackson"
    },
    "OKC067": {
        "ID": "OKZ045",
        "CID": "OKC067",
        "NAME": "Jefferson"
    },
    "OKC069": {
        "ID": "OKZ047",
        "CID": "OKC069",
        "NAME": "Johnston"
    },
    "OKC071": {
        "ID": "OKZ008",
        "CID": "OKC071",
        "NAME": "Kay"
    },
    "OKC073": {
        "ID": "OKZ018",
        "CID": "OKC073",
        "NAME": "Kingfisher"
    },
    "OKC075": {
        "ID": "OKZ035",
        "CID": "OKC075",
        "NAME": "Kiowa"
    },
    "OKC153": {
        "ID": "OKZ010",
        "CID": "OKC153",
        "NAME": "Woodward"
    },
    "OKC079": {
        "ID": "OKZ076",
        "CID": "OKC079",
        "NAME": "Le Flore"
    },
    "OKC081": {
        "ID": "OKZ026",
        "CID": "OKC081",
        "NAME": "Lincoln"
    },
    "OKC083": {
        "ID": "OKZ019",
        "CID": "OKC083",
        "NAME": "Logan"
    },
    "OKC085": {
        "ID": "OKZ050",
        "CID": "OKC085",
        "NAME": "Love"
    },
    "OKC087": {
        "ID": "OKZ028",
        "CID": "OKC087",
        "NAME": "McClain"
    },
    "OKC089": {
        "ID": "OKZ077",
        "CID": "OKC089",
        "NAME": "McCurtain"
    },
    "OKC091": {
        "ID": "OKZ071",
        "CID": "OKC091",
        "NAME": "McIntosh"
    },
    "OKC093": {
        "ID": "OKZ011",
        "CID": "OKC093",
        "NAME": "Major"
    },
    "OKC095": {
        "ID": "OKZ051",
        "CID": "OKC095",
        "NAME": "Marshall"
    },
    "OKC097": {
        "ID": "OKZ062",
        "CID": "OKC097",
        "NAME": "Mayes"
    },
    "OKC099": {
        "ID": "OKZ041",
        "CID": "OKC099",
        "NAME": "Murray"
    },
    "OKC101": {
        "ID": "OKZ070",
        "CID": "OKC101",
        "NAME": "Muskogee"
    },
    "OKC103": {
        "ID": "OKZ013",
        "CID": "OKC103",
        "NAME": "Noble"
    },
    "OKC105": {
        "ID": "OKZ056",
        "CID": "OKC105",
        "NAME": "Nowata"
    },
    "OKC107": {
        "ID": "OKZ065",
        "CID": "OKC107",
        "NAME": "Okfuskee"
    },
    "OKC109": {
        "ID": "OKZ025",
        "CID": "OKC109",
        "NAME": "Oklahoma"
    },
    "OKC111": {
        "ID": "OKZ066",
        "CID": "OKC111",
        "NAME": "Okmulgee"
    },
    "OKC113": {
        "ID": "OKZ054",
        "CID": "OKC113",
        "NAME": "Osage"
    },
    "OKC115": {
        "ID": "OKZ058",
        "CID": "OKC115",
        "NAME": "Ottawa"
    },
    "OKC117": {
        "ID": "OKZ059",
        "CID": "OKC117",
        "NAME": "Pawnee"
    },
    "OKC119": {
        "ID": "OKZ020",
        "CID": "OKC119",
        "NAME": "Payne"
    },
    "OKC121": {
        "ID": "OKZ073",
        "CID": "OKC121",
        "NAME": "Pittsburg"
    },
    "OKC123": {
        "ID": "OKZ042",
        "CID": "OKC123",
        "NAME": "Pontotoc"
    },
    "OKC125": {
        "ID": "OKZ030",
        "CID": "OKC125",
        "NAME": "Pottawatomie"
    },
    "OKC127": {
        "ID": "OKZ049",
        "CID": "OKC127",
        "NAME": "Pushmataha"
    },
    "OKC129": {
        "ID": "OKZ014",
        "CID": "OKC129",
        "NAME": "Roger Mills"
    },
    "OKC131": {
        "ID": "OKZ061",
        "CID": "OKC131",
        "NAME": "Rogers"
    },
    "OKC133": {
        "ID": "OKZ031",
        "CID": "OKC133",
        "NAME": "Seminole"
    },
    "OKC135": {
        "ID": "OKZ072",
        "CID": "OKC135",
        "NAME": "Sequoyah"
    },
    "OKC137": {
        "ID": "OKZ039",
        "CID": "OKC137",
        "NAME": "Stephens"
    },
    "OKC139": {
        "ID": "OKZ002",
        "CID": "OKC139",
        "NAME": "Texas"
    },
    "OKC141": {
        "ID": "OKZ037",
        "CID": "OKC141",
        "NAME": "Tillman"
    },
    "OKC143": {
        "ID": "OKZ060",
        "CID": "OKC143",
        "NAME": "Tulsa"
    },
    "OKC145": {
        "ID": "OKZ067",
        "CID": "OKC145",
        "NAME": "Wagoner"
    },
    "OKC147": {
        "ID": "OKZ055",
        "CID": "OKC147",
        "NAME": "Washington"
    },
    "OKC149": {
        "ID": "OKZ022",
        "CID": "OKC149",
        "NAME": "Washita"
    },
    "OKC151": {
        "ID": "OKZ005",
        "CID": "OKC151",
        "NAME": "Woods"
    },
    "OKC077": {
        "ID": "OKZ075",
        "CID": "OKC077",
        "NAME": "Latimer"
    },
    "OKC001": {
        "ID": "OKZ069",
        "CID": "OKC001",
        "NAME": "Adair"
    },
    "OKC003": {
        "ID": "OKZ006",
        "CID": "OKC003",
        "NAME": "Alfalfa"
    },
    "OKC005": {
        "ID": "OKZ048",
        "CID": "OKC005",
        "NAME": "Atoka"
    },
    "OKC007": {
        "ID": "OKZ003",
        "CID": "OKC007",
        "NAME": "Beaver"
    },
    "OKC009": {
        "ID": "OKZ021",
        "CID": "OKC009",
        "NAME": "Beckham"
    },
    "TXC111": {
        "ID": "TXZ001",
        "CID": "TXC111",
        "NAME": "Dallam"
    },
    "TXC119": {
        "ID": "TXZ106",
        "CID": "TXC119",
        "NAME": "Delta"
    },
    "TXC121": {
        "ID": "TXZ103",
        "CID": "TXC121",
        "NAME": "Denton"
    },
    "TXC129": {
        "ID": "TXZ019",
        "CID": "TXC129",
        "NAME": "Donley"
    },
    "TXC147": {
        "ID": "TXZ094",
        "CID": "TXC147",
        "NAME": "Fannin"
    },
    "TXC155": {
        "ID": "TXZ084",
        "CID": "TXC155",
        "NAME": "Foard"
    },
    "TXC159": {
        "ID": "TXZ108",
        "CID": "TXC159",
        "NAME": "Franklin"
    },
    "TXC179": {
        "ID": "TXZ014",
        "CID": "TXC179",
        "NAME": "Gray"
    },
    "TXC181": {
        "ID": "TXZ093",
        "CID": "TXC181",
        "NAME": "Grayson"
    },
    "TXC191": {
        "ID": "TXZ025",
        "CID": "TXC191",
        "NAME": "Hall"
    },
    "TXC195": {
        "ID": "TXZ003",
        "CID": "TXC195",
        "NAME": "Hansford"
    },
    "TXC197": {
        "ID": "TXZ083",
        "CID": "TXC197",
        "NAME": "Hardeman"
    },
    "TXC205": {
        "ID": "TXZ006",
        "CID": "TXC205",
        "NAME": "Hartley"
    },
    "TXC211": {
        "ID": "TXZ010",
        "CID": "TXC211",
        "NAME": "Hemphill"
    },
    "TXC223": {
        "ID": "TXZ107",
        "CID": "TXC223",
        "NAME": "Hopkins"
    },
    "TXC231": {
        "ID": "TXZ105",
        "CID": "TXC231",
        "NAME": "Hunt"
    },
    "TXC233": {
        "ID": "TXZ008",
        "CID": "TXC233",
        "NAME": "Hutchinson"
    },
    "TXC237": {
        "ID": "TXZ101",
        "CID": "TXC237",
        "NAME": "Jack"
    },
    "TXC269": {
        "ID": "TXZ038",
        "CID": "TXC269",
        "NAME": "King"
    },
    "TXC275": {
        "ID": "TXZ087",
        "CID": "TXC275",
        "NAME": "Knox"
    },
    "TXC277": {
        "ID": "TXZ095",
        "CID": "TXC277",
        "NAME": "Lamar"
    },
    "TXC295": {
        "ID": "TXZ005",
        "CID": "TXC295",
        "NAME": "Lipscomb"
    },
    "TXC337": {
        "ID": "TXZ091",
        "CID": "TXC337",
        "NAME": "Montague"
    },
    "TXC341": {
        "ID": "TXZ007",
        "CID": "TXC341",
        "NAME": "Moore"
    },
    "TXC343": {
        "ID": "TXZ111",
        "CID": "TXC343",
        "NAME": "Morris"
    },
    "TXC345": {
        "ID": "TXZ031",
        "CID": "TXC345",
        "NAME": "Motley"
    },
    "TXC357": {
        "ID": "TXZ004",
        "CID": "TXC357",
        "NAME": "Ochiltree"
    },
    "TXC375": {
        "ID": "TXZ012",
        "CID": "TXC375",
        "NAME": "Potter"
    },
    "TXC381": {
        "ID": "TXZ017",
        "CID": "TXC381",
        "NAME": "Randall"
    },
    "TXC387": {
        "ID": "TXZ096",
        "CID": "TXC387",
        "NAME": "Red River"
    },
    "TXC393": {
        "ID": "TXZ009",
        "CID": "TXC393",
        "NAME": "Roberts"
    },
    "TXC421": {
        "ID": "TXZ002",
        "CID": "TXC421",
        "NAME": "Sherman"
    },
    "TXC447": {
        "ID": "TXZ099",
        "CID": "TXC447",
        "NAME": "Throckmorton"
    },
    "TXC449": {
        "ID": "TXZ109",
        "CID": "TXC449",
        "NAME": "Titus"
    },
    "TXC483": {
        "ID": "TXZ015",
        "CID": "TXC483",
        "NAME": "Wheeler"
    },
    "TXC485": {
        "ID": "TXZ086",
        "CID": "TXC485",
        "NAME": "Wichita"
    },
    "TXC487": {
        "ID": "TXZ085",
        "CID": "TXC487",
        "NAME": "Wilbarger"
    },
    "TXC497": {
        "ID": "TXZ102",
        "CID": "TXC497",
        "NAME": "Wise"
    },
    "TXC503": {
        "ID": "TXZ100",
        "CID": "TXC503",
        "NAME": "Young"
    },
    "TXC087": {
        "ID": "TXZ020",
        "CID": "TXC087",
        "NAME": "Collingsworth"
    },
    "TXC085": {
        "ID": "TXZ104",
        "CID": "TXC085",
        "NAME": "Collin"
    },
    "TXC077": {
        "ID": "TXZ090",
        "CID": "TXC077",
        "NAME": "Clay"
    },
    "TXC075": {
        "ID": "TXZ026",
        "CID": "TXC075",
        "NAME": "Childress"
    },
    "TXC065": {
        "ID": "TXZ013",
        "CID": "TXC065",
        "NAME": "Carson"
    },
    "TXC067": {
        "ID": "TXZ112",
        "CID": "TXC067",
        "NAME": "Cass"
    },
    "TXC063": {
        "ID": "TXZ110",
        "CID": "TXC063",
        "NAME": "Camp"
    },
    "TXC037": {
        "ID": "TXZ097",
        "CID": "TXC037",
        "NAME": "Bowie"
    },
    "TXC023": {
        "ID": "TXZ088",
        "CID": "TXC023",
        "NAME": "Baylor"
    },
    "TXC011": {
        "ID": "TXZ018",
        "CID": "TXC011",
        "NAME": "Armstrong"
    },
    "TXC009": {
        "ID": "TXZ089",
        "CID": "TXC009",
        "NAME": "Archer"
    },
    "TXC097": {
        "ID": "TXZ092",
        "CID": "TXC097",
        "NAME": "Cooke"
    },
    "TXC101": {
        "ID": "TXZ032",
        "CID": "TXC101",
        "NAME": "Cottle"
    }
};

OCS.Constants.PANEL_LAYOUTS = {
    "two_by_two": {
      "name": "4 Panel (default)",
      "id": "panel_container",
      "num_of_panels": 4,
      "template": "two_by_two",
      "is_default": true
    },
    "single": {
      "name": "Single Panel",
      "id": "panel_container",
      "num_of_panels": 1,
      "template": "single",
      "is_default": false
    },
    "one_by_one_horiz": {
      "name": "2 Panel (side by side)",
      "id": "panel_container",
      "num_of_panels": 2,
      "template": "one_by_one_horiz",
      "is_default": false
    },
    "one_by_one_vert": {
      "name": "2 Panel (over/under)",
      "id": "panel_container",
      "num_of_panels": 2,
      "template": "one_by_one_vert",
      "is_default": false
    },
    "one_by_two_vert": {
      "name": "3 Panel (over/under)",
      "id": "panel_container",
      "num_of_panels": 3,
      "template": "one_by_two_vert",
      "is_default": false
    },
    "two_by_one_horiz": {
      "name": "3 Panel (side by side)",
      "id": "panel_container",
      "num_of_panels": 3,
      "template": "two_by_one_horiz",
      "is_default": false
    },
    "three_by_one": {
      "name": "4 Panel (alternative)",
      "id": "panel_container",
      "num_of_panels": 4,
      "template": "three_by_one",
      "is_default": false
    }
};

OCS.Constants.RADAR_LOCATIONS = [
    {
        id: 'KAMA',
        name: 'Amarillo',
        lat: 35.2333,
        lon: -101.7092
    },
    {
        id: 'KDDC',
        name: 'Dodge City',
        lat: 37.7608,
        lon: -99.9686
    },
    {
        id: 'KDYX',
        name: 'Dyess AFB',
        lat: 32.5383,
        lon: -99.2544
    },
    {
        id: 'KFDR',
        name: 'Frederick',
        lat: 34.3622,
        lon: -98.9764
    },
    {
        id: 'KFWS',
        name: 'Dallas-Ft. Worth',
        lat: 32.5731,
        lon: -97.3031
    },
    {
        id: 'KICT',
        name: 'Wichita',
        lat: 37.6547,
        lon: -97.4428
    },
    {
        id: 'KINX',
        name: 'Tulsa',
        lat: 36.175,
        lon: -95.5647
    },
    {
        id: 'KLBB',
        name: 'Lubbock',
        lat: 33.6542,
        lon: -101.8142
    },
    {
        id: 'KLZK',
        name: 'Little Rock',
        lat: 34.8364,
        lon: -92.2622
    },
    {
        id: 'KPUX',
        name: 'Pueblo',
        lat: 38.4594,
        lon: -104.1814
    },
    {
        id: 'KSGF',
        name: 'Springfield',
        lat: 37.2353,
        lon: -93.4006
    },
    {
        id: 'KSHV',
        name: 'Shreveport',
        lat: 32.4508,
        lon: -93.8414
    },
    {
        id: 'KSRX',
        name: 'Ft. Smith',
        lat: 35.2906,
        lon: -94.3617
    },
    {
        id: 'KTLX',
        name: 'Oklahoma City',
        lat: 35.3331,
        lon: -97.2778
    },
    {
        id: 'KVNX',
        name: 'Vance AFB',
        lat: 36.7408,
        lon: -98.1278
    },
];

if (OCS.is_on_production_server()) {
    OCS.Constants.DEBUG = false;
}
